import { Button, useDisclosure } from '@chakra-ui/core';
import { PropsOf } from 'emotion-theming/types/helper';
import React from 'react';
import WalletSettingsModal from './WalletSettingsModal';

const WalletSettingsButton = (props: PropsOf<typeof Button>) => {
  const { onOpen, onClose, isOpen } = useDisclosure();

  return (
    <>
      <WalletSettingsModal onClose={onClose} isOpen={isOpen} />
      <Button
        variant="outline"
        size="sm"
        colorScheme="blue"
        onClick={onOpen}
        {...props}
      >
        Wallet Settings
      </Button>
    </>
  );
};

export default WalletSettingsButton;
